module.exports = __webpack_public_path__ + "kudos_87.svg?61fa9d82e4dbc14c4b67620398f67e34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_87.svg
// module id = 191
// module chunks = 0